'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _class, _temp;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _templateObject = _taggedTemplateLiteral(['\n  ', '\n'], ['\n  ', '\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Renderer = require('./Renderer');

var _Renderer2 = _interopRequireDefault(_Renderer);

var _graphql = require('graphql');

var _context = require('@prisma-cms/context');

var _context2 = _interopRequireDefault(_context);

var _MuiThemeProvider = require('material-ui/styles/MuiThemeProvider');

var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);

var _createMuiTheme = require('material-ui/styles/createMuiTheme');

var _createMuiTheme2 = _interopRequireDefault(_createMuiTheme);

var _blue = require('material-ui/colors/blue');

var _blue2 = _interopRequireDefault(_blue);

var _pink = require('material-ui/colors/pink');

var _pink2 = _interopRequireDefault(_pink);

var _colorManipulator = require('material-ui/styles/colorManipulator');

var _reactApollo = require('react-apollo');

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

var _createTypography = require('material-ui/styles/createTypography');

var _createTypography2 = _interopRequireDefault(_createTypography);

var _createPalette = require('material-ui/styles/createPalette');

var _createPalette2 = _interopRequireDefault(_createPalette);

var _urijs = require('urijs');

var _urijs2 = _interopRequireDefault(_urijs);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
} // import lightBlue from 'material-ui/colors/lightBlue';
// import UriProvider from "../../modules/uri-provider";


var sheetsManager = new Map(); // const theme = createMuiTheme({
//   palette: {
//   },
//   typography: {
//     fontFamily: "Tahoma, Helvetica, sans-serif",
//     fontSize: 14,
//   },
// });

function _getTheme(uiTheme) {
  var direction = uiTheme.direction,
      paletteType = uiTheme.paletteType,
      other = _objectWithoutProperties(uiTheme, ['direction', 'paletteType']);

  var palette = (0, _createPalette2.default)({
    type: paletteType,
    primary: _extends({}, _blue2.default),
    secondary: {
      // Darken so we reach the AA contrast ratio level.
      main: (0, _colorManipulator.darken)(_pink2.default.A400, 0.08)
    }
  }); // let palette = {
  //   primary: {
  //     ...blue,
  //     // main: "#ff0000",
  //   },
  //   secondary: {
  //     // Darken so we reach the AA contrast ratio level.
  //     main: darken(pink.A400, 0.08),
  //   },
  //   type: paletteType,
  // }
  // const typography = createTypography(palette, {
  //   fontFamily: '"Roboto"',
  // });

  var theme = (0, _createMuiTheme2.default)(_extends({
    direction: direction,
    nprogress: {
      color: paletteType === 'light' ? '#000' : '#fff'
    },
    palette: palette
  }, other)); // Expose the theme as a global variable so people can play with it.

  if (process.browser) {
    global.theme = theme;
  }

  return theme;
}

var schema = void 0;
var SchemaLoaderQuery = (0, _reactApollo.graphql)((0, _graphqlTag2.default)(_templateObject, _graphql.introspectionQuery), {
  options: {
    // fetchPolicy: typeof window === "undefined" ? "no-cache" : "cache-first",
    fetchPolicy: "no-cache"
  }
})(function (props) {
  var introspection = props.data,
      children = props.children,
      onSchemaLoad = props.onSchemaLoad;
  var __schema = introspection.__schema;

  if (__schema && !schema) {
    // console.log("__schema loaded", __schema);
    // console.log("__schema print", print(__schema));
    var clientSchema = (0, _graphql.buildClientSchema)(introspection);
    var schemaSDL = (0, _graphql.printSchema)(clientSchema, {// commentDescriptions: false,
    }); // console.log("__schema schemaSDL", schemaSDL);
    // console.log("__schema parse schemaSDL", parse(schemaSDL));
    // console.log("__schema parse buildSchema", buildSchema(schemaSDL));
    // console.log("__schema parse buildSchema", buildSchema(schemaSDL));
    // console.log("__schema parse introspectionFromSchema", introspectionFromSchema(buildSchema(schemaSDL)));
    // console.log("__schema buildClientSchema", clientSchema);
    // console.log("__schema introspectionFromSchema", introspectionFromSchema(clientSchema).__schema);

    schema = __schema;
    onSchemaLoad && onSchemaLoad(schemaSDL);
  }

  return _react2.default.createElement(_context2.default.Consumer, null, function (context) {
    return _react2.default.createElement(_context2.default.Provider, {
      value: _extends({}, context, {
        schema: schema
      })
    }, children);
  });
});

var SchemaLoader = function (_Component) {
  _inherits(SchemaLoader, _Component);

  function SchemaLoader() {
    _classCallCheck(this, SchemaLoader);

    return _possibleConstructorReturn(this, (SchemaLoader.__proto__ || Object.getPrototypeOf(SchemaLoader)).apply(this, arguments));
  }

  _createClass(SchemaLoader, [{
    key: 'componentWillMount',
    // static contextType = Context;
    value: function componentWillMount() {
      var _global = global,
          __PRISMA_CMS_API_SCHEMA_DSL__ = _global.__PRISMA_CMS_API_SCHEMA_DSL__,
          __PRISMA_CMS_API_SCHEMA__ = _global.__PRISMA_CMS_API_SCHEMA__; // console.log("__PRISMA_CMS_API_SCHEMA_DSL__", __PRISMA_CMS_API_SCHEMA_DSL__);

      if (__PRISMA_CMS_API_SCHEMA_DSL__) {
        // schema = introspectionFromSchema(__PRISMA_CMS_API_SCHEMA_DSL__).__schema;
        // console.log("__schema parse __PRISMA_CMS_API_SCHEMA_DSL__", __PRISMA_CMS_API_SCHEMA_DSL__);
        // console.log("__schema parse buildSchema", buildSchema(__PRISMA_CMS_API_SCHEMA_DSL__));
        // console.log("__schema parse introspectionFromSchema", introspectionFromSchema(buildSchema(__PRISMA_CMS_API_SCHEMA_DSL__)));
        schema = (0, _graphql.introspectionFromSchema)((0, _graphql.buildSchema)(__PRISMA_CMS_API_SCHEMA_DSL__)).__schema;
      } else if (__PRISMA_CMS_API_SCHEMA__) {
        schema = __PRISMA_CMS_API_SCHEMA__;
      }

      _get(SchemaLoader.prototype.__proto__ || Object.getPrototypeOf(SchemaLoader.prototype), 'componentWillMount', this) && _get(SchemaLoader.prototype.__proto__ || Object.getPrototypeOf(SchemaLoader.prototype), 'componentWillMount', this).call(this);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          _onSchemaLoad = _props.onSchemaLoad;
      /* 
      Если схема не была подгружена, то вызываем загрузчик.
      После того, как он схему подгрузит, он нам уже не нужен.
      На сервере надо соблюсти вложенность, чтобы обязательно в контакст попала схема
      */
      // if (false || typeof window === "undefined") {
      //   return <SchemaLoaderQuery
      //     onSchemaLoad={(schema) => {
      //       onSchemaLoad && onSchemaLoad(schema);
      //       this.forceUpdate();
      //     }}
      //   >
      //     {children}
      //   </SchemaLoaderQuery>;
      // }
      // else {

      return _react2.default.createElement(_context2.default.Consumer, null, function (context) {
        return _react2.default.createElement(_context2.default.Provider, {
          value: !schema || context && context.schema === schema ? context : _extends({}, context, {
            schema: schema
          })
        }, !schema ? _react2.default.createElement(SchemaLoaderQuery, {
          onSchemaLoad: function onSchemaLoad(schema) {
            _onSchemaLoad && _onSchemaLoad(schema);

            _this2.forceUpdate();
          }
        }) : null, children);
      }); // }
    }
  }]);

  return SchemaLoader;
}(_react.Component);

var App = (_temp = _class = function (_Component2) {
  _inherits(App, _Component2);

  function App(props) {
    _classCallCheck(this, App);

    var _this3 = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));

    var themeOptions = props.themeOptions;
    _this3.state = _extends({}, _this3.state, {
      themeOptions: themeOptions
    });

    _this3.initLanguage();

    Object.assign(_this3.state, {
      theme: _this3.getTheme()
    }); // console.log("Front App constructor", this.props);

    _this3.updateTheme = _this3.updateTheme.bind(_this3);
    _this3.getQuery = _this3.getQuery.bind(_this3);
    _this3.getQueryFragment = _this3.getQueryFragment.bind(_this3);
    _this3.setLanguage = _this3.setLanguage.bind(_this3);
    _this3.getLanguage = _this3.getLanguage.bind(_this3);
    return _this3;
  }

  _createClass(App, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var theme = this.state.theme;
      var lang = this.getLanguage();
      return {
        theme: theme,
        updateTheme: this.updateTheme,
        getQuery: this.getQuery,
        getQueryFragment: this.getQueryFragment,
        setLanguage: this.setLanguage,
        getLanguage: this.getLanguage,
        lang: lang
      };
    }
  }, {
    key: 'initLanguage',
    value: function initLanguage() {
      var lang = this.props.lang;

      if (!lang) {
        var _global2 = global,
            navigator = _global2.navigator,
            localStorage = _global2.localStorage;
        lang = localStorage && localStorage.prismaCmsLang || navigator && navigator.language || "en-En";
      }

      lang = lang && lang.substr(0, 2) || "en-En";
      Object.assign(this.state, {
        lang: lang
      });
    }
  }, {
    key: 'setLanguage',
    value: function setLanguage(lang) {
      var _global3 = global,
          localStorage = _global3.localStorage;

      if (localStorage) {
        localStorage.setItem("prismaCmsLang", lang);
      }

      this.setState({
        lang: lang
      });
    }
  }, {
    key: 'getLanguage',
    value: function getLanguage() {
      var lang = this.state.lang;
      return lang;
    }
  }, {
    key: 'getTheme',
    value: function getTheme() {
      var themeOptions = this.state.themeOptions;
      return _getTheme(_extends({}, themeOptions));
    }
  }, {
    key: 'updateTheme',
    value: function updateTheme(options) {
      var _this4 = this;

      var themeOptions = this.state.themeOptions;
      this.setState({
        themeOptions: _extends({}, themeOptions, options)
      }, function () {
        _this4.setState({
          theme: _this4.getTheme()
        });
      });
    }
  }, {
    key: 'getQuery',
    value: function getQuery(operation) {}
  }, {
    key: 'getQueryFragment',
    value: function getQueryFragment(fragmentName) {
      var _ref = this.props.queryFragments || {},
          fragment = _ref[fragmentName];

      if (!fragment) {
        throw new Error('Can not get query fragment "' + fragmentName + '"');
      }

      return fragment;
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== "undefined") {
        // Удаляем стили, сгенерированные сервером, так как они могут не соответствовать реальным стилям
        var styles = document.querySelector("#server-side-jss");
        styles && styles.remove();
      }

      var uri = this.props.uri; // console.log("location uri", uri);

      if (!uri) {
        var _global4 = global,
            location = _global4.location;

        if (!location) {
          // location = this.context.router.history.location;
          // const {
          //   router: {
          //     history,
          //   },
          // } = this.context;
          // const {
          //   location: routerLocation,
          //   createHref,
          // } = history;
          // // console.log("location this.context.router", this.context.router);
          // location = createHref(routerLocation);

          /**
           * В режиме SSR uri надо обязательно получать, так как 
           * из реакт-роутера location без домена
           */
          throw new Error("Can not get location");
        } // console.log("location this.context.router", this.context.router);
        // console.log("location", location);


        uri = new _urijs2.default(location);
      } // console.log("location uri", uri, uri && uri.toString());


      Object.assign(this.state, {
        uri: uri
      });
      _get(App.prototype.__proto__ || Object.getPrototypeOf(App.prototype), 'componentWillMount', this) && _get(App.prototype.__proto__ || Object.getPrototypeOf(App.prototype), 'componentWillMount', this).call(this);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.initCounters();
      _get(App.prototype.__proto__ || Object.getPrototypeOf(App.prototype), 'componentDidMount', this) && _get(App.prototype.__proto__ || Object.getPrototypeOf(App.prototype), 'componentDidMount', this).call(this);
    }
  }, {
    key: 'initCounters',
    value: function initCounters() {
      var _this5 = this;

      var router = this.context.router;
      var history = router.history;

      if (typeof window !== "undefined") {
        history.listen(function () {
          var _global5 = global,
              location = _global5.location;

          if (location) {
            var newUri = new _urijs2.default(location);
            var newHref = newUri.resource();

            if (newHref) {
              var uri = _this5.state.uri;
              var currentHref = uri.resource();

              if (currentHref && newHref && currentHref !== newHref) {
                // console.log("history location changed currentHref", uri, currentHref, newHref, currentHref === newHref);
                _this5.setState({
                  uri: newUri
                }, function () {
                  try {
                    // Это надо чтобы при смене страницы отправлялась статистика в гугл
                    var _global6 = global,
                        Ya = _global6.Ya,
                        gtag = _global6.gtag,
                        dataLayer = _global6.dataLayer;

                    var _ref2 = Ya || {},
                        _metrika = _ref2._metrika; // const yaCounters = Metrika && Metrika.counters() || [];


                    var _ref3 = _metrika || {},
                        yaCounter = _ref3.counter; // Отправка данных в яндекс.метрику


                    yaCounter && yaCounter.clickmap && yaCounter.clickmap().hit(location.pathname); // Отправка данных в гугл

                    var googleAnalyticsConfig = dataLayer && dataLayer.find(function (n) {
                      return n && n[0] === "config" && n[1];
                    });

                    var _ref4 = googleAnalyticsConfig || {},
                        googleAnalyticsId = _ref4[1];

                    gtag && googleAnalyticsId && gtag('event', 'page_view', {
                      send_to: googleAnalyticsId,
                      page_path: location.pathname,
                      page_title: window.document.tittle,
                      page_location: location.toString()
                    });
                  } catch (error) {
                    console.error(error);
                  }
                });
              }
            }
          }
        });
      }

      return;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var _props2 = this.props,
          themeOptions = _props2.themeOptions,
          Renderer = _props2.Renderer,
          sheetsManager = _props2.sheetsManager,
          assetsBaseUrl = _props2.assetsBaseUrl,
          onSchemaLoad = _props2.onSchemaLoad,
          other = _objectWithoutProperties(_props2, ['themeOptions', 'Renderer', 'sheetsManager', 'assetsBaseUrl', 'onSchemaLoad']);

      var _state = this.state,
          theme = _state.theme,
          uri = _state.uri;
      var currentUser = this.context.user;

      var _ref5 = currentUser || {},
          currentUserId = _ref5.id;

      return _react2.default.createElement(SchemaLoader, {
        onSchemaLoad: onSchemaLoad
      }, _react2.default.createElement(_MuiThemeProvider2.default, {
        theme: theme,
        sheetsManager: sheetsManager
      }, _react2.default.createElement(_context2.default.Consumer, null, function (context) {
        return _react2.default.createElement(_context2.default.Provider, {
          value: Object.assign(context, _this6.context, _extends({}, _this6.getChildContext(), {
            assetsBaseUrl: assetsBaseUrl,
            uri: uri
          }))
        }, _react2.default.createElement(Renderer // key={currentUserId}
        , other));
      })));
    }
  }]);

  return App;
}(_react.Component), _class.propTypes = {
  Renderer: _propTypes2.default.func.isRequired,
  themeOptions: _propTypes2.default.object.isRequired,
  queryFragments: _propTypes2.default.object,
  lang: _propTypes2.default.string,
  sheetsManager: _propTypes2.default.object,
  assetsBaseUrl: _propTypes2.default.string,

  /**
   * Это надо для сохранения схемы в режиме SSR
   */
  onSchemaLoad: _propTypes2.default.func
}, _class.defaultProps = {
  Renderer: _Renderer2.default,
  themeOptions: {
    direction: 'ltr',
    // paletteType: 'dark',
    paletteType: 'light'
  },
  lang: null,
  sheetsManager: sheetsManager
}, _class.contextTypes = {
  client: _propTypes2.default.object.isRequired,
  router: _propTypes2.default.object.isRequired,
  errors: _propTypes2.default.array.isRequired,
  user: _propTypes2.default.object,
  logout: _propTypes2.default.func.isRequired,
  loadApiData: _propTypes2.default.func.isRequired,
  onAuthSuccess: _propTypes2.default.func.isRequired
}, _class.childContextTypes = {
  theme: _propTypes2.default.object,
  updateTheme: _propTypes2.default.func,
  getQuery: _propTypes2.default.func,
  getQueryFragment: _propTypes2.default.func,
  lang: _propTypes2.default.string,
  setLanguage: _propTypes2.default.func,
  getLanguage: _propTypes2.default.func
}, _temp);
exports.default = App;
module.exports = exports['default'];